import { render, staticRenderFns } from "./TypeProduct.vue?vue&type=template&id=08369536&"
import script from "./TypeProduct.vue?vue&type=script&lang=js&"
export * from "./TypeProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports